export default __webpack_public_path__ + "static/media/no_applied_jobs@3x.297bba6d.png";